<template lang="pug">
  .site-container
    .empty-page
      .empty-page-container
        .empty-page-content(v-if="result === true") Автоплатеж успешно отключен
        .empty-page-content(v-if="result === false") Ошибка! Пожалуйста, обратитесь в техническую поддержку
        AuthFooter
</template>

<script>
import AuthFooter from '@/components/AuthFooter.vue';

import api from '@/api/user';

export default {
  components: { AuthFooter },
  data() {
    return {
      result: null,
    };
  },
  mounted() {
    const userId = document.location.search
      ?.replace('?', '')
      ?.split('&')
      ?.find((parameter) => parameter.includes('id'))
      ?.split('=')[1];

    const params = {
      verifyingUrl: document.location.href.replace(':8080', ':8097'),
      id: userId,
    };

    console.log(params);

    api.autopayDisable(params)
      .then(() => { this.result = true; })
      .catch(() => { this.result = false; });
  },
};
</script>

<style lang="scss" scoped>

</style>
